import { HttpClient } from '@angular/common/http'
import { Component } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { AlertController, IonicPage, LoadingController, NavController, NavParams, ToastController, ModalController } from 'ionic-angular'
import { tap } from 'rxjs/operators'

import { DealStatus, Contact } from '../../models/models'
import { ApiProvider } from '../../providers/api/api'
import { ContactProvider } from '../../providers/api/contacts.provider'
import { OperatorProvider } from '../../providers/operator/operator'
import { SettingsProvider } from '../../providers/settings/settings'
import { AddMeetingPage } from '../add-meeting/add-meeting';

@IonicPage()
@Component({
  selector: 'page-add-contact',
  templateUrl: 'add-contact.html',
})
export class AddContactPage {

  private formContact: FormGroup;
  private operator_id: number
  private contact: Contact
  private statusCode: number
  // private LIST_ID: number = 23

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private api: ApiProvider,
    private contactProvider: ContactProvider,
    private toastCtrl: ToastController,
    private loading: LoadingController,
    private alertCtrl: AlertController,
    private operatorProvider: OperatorProvider,
    private settings: SettingsProvider,
    private modalCtrl: ModalController
  ) {
    this.formContact = this.formBuilder.group({
      name: ['', Validators.required],
      surname: ['',],
      company: ['',],
      phone: ['', Validators.required],
      email: ['', Validators.compose([Validators.email, Validators.required])],
    });
    this.operatorProvider.currentOperator.subscribe(operator => {
      this.operator_id = operator ? operator.id : 0
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddContactPage');
  }

  postOnAc(name: string, surname: string, email: string, phone: string, company: string, operator_name: string) {
    let url = "https://mypushop.activehosted.com/proc.php?u=2&f=2&s=&c=0&m=0&act=sub&v=2&"
      + "field[3]=" + company  //"Nome attività"
      + "&fullname=" + name + " " + surname //"Nome negoziante"
      + "&field[4]=" + operator_name  //"Nome venditore"
      + "&phone=" + phone //"Numero di telefono negoziante"
      + "&email=" + email //"Email negoziante"
      + "&jsonp=true"

    return this.http.post<any>(url, {})
  }

  saveContact() {
    if (!this.formContact.valid) {
      this.toastCtrl.create({
        message: `Compila tutti i campi richiesti`,
        duration: 2000,
        position: 'top'
      }).present();
      return;
    } else {
      let l = this.loading.create({
        content: "Attendere.."
      })

      // Invio a Crm diretto
      this.contactProvider.postContact(this.operator_id, this.formContact.value, this.settings.SOURCE_DEFAULT)
      .pipe(
        tap(response => {
          this.contact = response.body
          this.contactProvider.postContactInList(this.contact.id, this.settings.LIST_ID).subscribe()
        })
      )
        .concatMap(response => {
          this.statusCode = response.status
          let deal = this.contact.deals.find(deal => deal.product.ac_label == this.settings.PRODUCT_MYP)
          if (deal != null) {
            if (deal.status === DealStatus.LOST) {
              deal.status = DealStatus.OPEN
            } else if (deal.status === DealStatus.WON) {
              let err = new Error('Deal già vinto')
              err.name = 'deal-won'
              throw err
            }
            deal.current_pipeline = this.settings.PIPELINE_VISTE_FREDDE
            deal.current_stage = this.settings.STAGE_PROBLEM_UNAWARE
            deal.current_operator = this.operator_id
            return this.api.patchDeal(deal)
          } else {
            return this.api.postDeal(
              this.contact.id,
              this.settings.PRODUCT_MYP_ID,
              this.settings.PIPELINE_VISTE_FREDDE,
              this.settings.STAGE_PROBLEM_UNAWARE,
              this.operator_id
            ).pipe(tap(
              _ => {
                this.contactProvider.pushOnAC(this.contact.id).subscribe(_ => {
                })
              }
            ))
          }
        })
        .subscribe(
          _ => {
            l.dismiss()
            if (this.statusCode == 202) {
              this.alertCtrl.create({
                title: "Contatto Esistente",
                message: "Il contatto è già presente. Vuoi fissare un appuntamento?",
                buttons: [
                  {
                    text: 'Annulla',
                    role: 'cancel',
                    handler: () => {
                      console.log('Cancel clicked');
                    }
                  },
                  {
                    text: 'Fissa Appuntamento',
                    handler: () => {
                      this.navCtrl.pop()
                      this.addMeeting(this.contact)
                    }
                  },
                ]
              }).present()
            } else {
              this.alertCtrl.create({
                title: "Contatto Creato",
                message: "Il contatto è stato salvato con successo",
                buttons: [
                  {
                    text: 'Ok',
                    handler: () => {
                      this.navCtrl.pop()
                    }
                  },
                ]
              }).present()
            }
          },
          e => {
            console.log('Si è verificato un errore', e)
            l.dismiss()

            if (e.status == 409) {
              this.alertCtrl.create({
                title: "Contatto Esistente",
                message: "Il contatto è già presente e assegnato ad un operatore. Contatta l'assistenza",
                buttons: [
                  {
                    text: 'Ok',
                    handler: () => {
                      this.navCtrl.pop()
                    }
                  },
                ]
              }).present()
            } else {
              let message = e.name === 'deal-won' ? 'Il contatto risulta già essere attivo e non può essere riassegnato' : `Si è verificato un errore`
              this.toastCtrl.create({
                message: message,
                duration: 2000,
                position: 'top'
              }).present();
            }
          }
        )
    }
  }

  addMeeting(contact) {
    console.log("Contatto per appuntamento", contact)
    let deal = contact.deals.find(deal => deal.product.ac_label == this.settings.PRODUCT_MYP)
    let meetingModal = this.modalCtrl.create(AddMeetingPage, { contact: contact, deal: deal }, { showBackdrop: true })
    meetingModal.onDidDismiss(_value => {
    })
    meetingModal.present()
  }
}



// WEBPACK FOOTER //
// ./src/pages/add-contact/add-contact.ts